import disableElement from '../../utils/disableElement';
import rules from '../../utils/rbac-rules';

const check = (rules: any, role: any, action: any, data: any, profile?: string[]) => {
  if(profile && disableElement(profile)) {
    return false
  }
  const permissions = rules[role];
  if (!permissions) {
    // role is not present in the rules
    return false;
  }

  const staticPermissions = permissions.static;

  if (staticPermissions && staticPermissions.includes(action)) {
    // static rule not provided for action
    return true;
  }

  const dynamicPermissions = permissions.dynamic;

  if (dynamicPermissions) {
    const permissionCondition = dynamicPermissions[action];
    if (!permissionCondition) {
      // dynamic rule not provided for action
      return false;
    }

    return permissionCondition(data);
  }
  return false;
};

const Can = (props: any) =>
  check(rules, props.role, props.perform, props.data, props.profile)
    ? props.yes()
    : props.no();

Can.defaultProps = {
  yes: () => null,
  no: () => null,
};

export default Can;
